<template>
    <div class="solution">
        <swiper>
            <swiper-slide class="solution-tiny" v-for="(item, index) in list" :key="index">
                <img :src="item" alt="" srcset="">
            </swiper-slide>
        </swiper>
        <InnerTitle :list="titles" @action="actionFunc" :active="active"></InnerTitle>
        <!-- tab1 -->
        <div v-show="active === 0">
            <GlobalTitlte En="Market Interpretation" :Zh="$t('solution.p1')" class="global-margin global-inner">
                <template #right>
                    <div class="gloabl-title-right">
                        <!-- {{ $t("home.i2") }} -->
                    </div>
                </template>
            </GlobalTitlte>
            <div class="bg-item-color global-t-bt">
                <div class="global-margin global-inner ">
                    <MarketInterpretation :swidth="swidth" class="market-header_content margin-center" />
                    <div class="market-header_words margin-center fw-n mt-10">
                        {{ $t("solution.p2") }}
                    </div>
                </div>
            </div>
            <GlobalTitlte En="Solution Experience Pain Points" :Zh="$t('solution.p3')"
                class="global-margin global-inner">
                <template #right>
                    <div class="gloabl-title-right">
                    </div>
                </template>
            </GlobalTitlte>
            <div :class="[swidth > 768 ? 'flex' : '', 'global-margin']">
                <NormalWithWords v-for="(item, index) in painPointsList" :key="index" :photo="item.pic"
                    :shade="swidth > 768 ? 'always' : 'always'" :alt="item.title"
                    :class="[swidth > 768 ? 'solution-pc-words' : 'solution-m-words', 'home-case-flex']"
                    :showDefaultWords="swidth > 768 ? true : false" :showWords="true">
                    <template #words>
                        <div class="solution-inner">
                            <div class="words">
                                <div class="title home-case-title">{{ item.title }}</div>
                                <div class="time" v-for="(it, idx) in item.words" :key="idx">{{ it }}</div>
                            </div>
                        </div>
                    </template>
                </NormalWithWords>
            </div>
        </div>
        <!-- tab2 -->
        <div v-show="active === 1" class="global-margin  mb-40">
            <img :class="['global-margin', 'm-auto', swidth > 768 ? 'mt-minus-40' : '', 'w-100']"
                :src="swidth > 768 ? solution[lang][0] : solution[lang][1]" alt="" srcset="">
            <div :class="['solutionTabs', 'flex', 'flex-wrap', 'm-auto', 'mt-20', swidth > 768 ? 'w-100' : 'w-90']">
                <div v-for="(item, index) in solutionTabs" @click="solutionClick(item, index)"
                    :class="[stabActive === index ? 'solution-tabs-active' : 'solution-tabs']" :key="index">{{
                        item.category_name
                    }}</div>
            </div>
            <div class="flex flex-wrap m-auto mt-40  w-100" v-loading="loading">
                <solutionCard v-for="(card, index) in curentPageData" class="card relative" :key="index"
                    :solution="card" :it="el[card.id]" :id="card.id" style="cursor: pointer" />
                <el-empty class="m-auto" description="暂无数据" :image-size="swidth > 768 ? 200 : 100"
                    v-show="!curentPageData.length"></el-empty>
            </div>
            <el-pagination style="text-align: center; margin: 40px auto; margin-bottom: 50px" background
                layout="prev, pager, next" :page-size="page_size" :total="total" :current-page.sync="page"
                @current-change="handleCurrentChange" v-if="curentPageData.length && total_page > 1"></el-pagination>
        </div>
        <!-- tab3 -->
        <div v-show="active === 2" class="global-margin">
            <GlobalTitlte En="Service Process" :Zh="$t('solution.p4')" class=" global-inner">
                <template #right>
                    <div class="gloabl-title-right">
                        <!-- {{ $t("home.i2") }} -->
                    </div>
                </template>
            </GlobalTitlte>
            <img :class="['global-margin  mt-20 mb-40 m-auto', swidth > 768 ? '' : 'w-90', 'w-100']"
                :src="swidth > 768 ? service[lang][0] : service[lang][1]" alt="" srcset="">
        </div>
    </div>
</template>
<script>
import InnerTitle from '../components/InnerTitle.vue';
import GlobalTitlte from '../components/GlobalTitlte.vue'
import MarketInterpretation from "../components/MarketInterpretation";
import NormalWithWords from "../components/NormalWithWords";
import solutionCard from "../components/solutionCard";


import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    components: {
        GlobalTitlte,
        InnerTitle,
        MarketInterpretation,
        NormalWithWords,
        solutionCard,
        swiper, swiperSlide
    },
    props: {
        swidth: {
            type: Number
        }
    },
    data() {
        return {
            swiperOptionThumbs: {
                loop: true,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
            },
            el: {},
            list: [],
            lang: localStorage.getItem("333f-locale-lang") || "zh_cn",
            titles: [{
                id: 0,
                title: this.$t("solution.o1"),
            }, {
                id: 1,
                title: this.$t("solution.o2"),
            }, {
                id: 2,
                title: this.$t("solution.o3"),
            },],
            painPointsList: [
                {
                    pic: require("@/assets/images/solution1.png"),
                    title: this.$t("solution.i1"),
                    words: [
                        this.$t("solution.i2"),
                        this.$t("solution.i3"),
                        this.$t("solution.i4"),
                    ],
                },
                {
                    pic: require("@/assets/images/solution2.png"),
                    title: this.$t("solution.i5"),
                    words: [
                        this.$t("solution.i6"),
                        this.$t("solution.i7"),
                        this.$t("solution.i8"),
                    ],
                },
            ],
            solution: {
                zh_cn: [
                    require("@/assets/images/solution-case.png"),
                    require("@/assets/images/solution-case-m.png"),
                ],
                us_en: [
                    require("@/assets/images/solution-case-en.png"),
                    require("@/assets/images/solution-case-m-en.png"),
                ]
            },
            service: {
                zh_cn: [
                    require("@/assets/images/solution-check-pc.png"),
                    require("@/assets/images/solution-check-pc.png"),
                    // require("@/assets/images/solution-check-m.png"),
                ],
                us_en: [
                    require("@/assets/images/solution-check-pc-en.png"),
                    require("@/assets/images/solution-check-pc-en.png"),
                    // require("@/assets/images/solution-check-m-en.png"),
                ]
            },
            curentPageData: [],
            solutionTabs: [],
            solutionData: [],
            stabActive: 0,
            loading: true,
            active: 0,
            page_size: 12,
            total: 0,
            total_page: 0,
            page: 1
        };
    },
    mounted() {
        this.getsolutionData()
        this.getSolutionTabs('getbanner')
        this.getSolutionTabs()
    },
    methods: {
        actionFunc(item) {
            this.active = item.id
            if (item.id == 1)
                this.solutionClick(1, 0)

        },
        solutionClick(item, index) {
            this.page = 1
            this.loading = true
            this.stabActive = index
            this.getsolutionData(this.page, item.id)
        },
        getsolutionData(page = 1, category_id) {
            this.page = page
            this.category_id = category_id
            this.$http.get("/api/solution/pageList", {
                page: this.page,
                per_page: this.page_size,
                category_id: this.category_id,
                latest: this.category_id ? 0 : 1
            }).then((res) => {
                if (res.code == 200) {
                    this.curentPageData = res.data.data;
                    this.total = res.data.total
                    this.total_page = res.data.last_page
                    this.loading = false
                } else {
                    this.loading = false
                    // this.$message.error(res.msg);
                }
            });
        },
        handleCurrentChange(page) {
            this.getsolutionData(page, this.category_id)
        },
        getSolutionTabs(type) {
            this.$http.get('/common/category/getList', {
                pid: type ? 0 : sessionStorage.getItem('333f-now-tab') || 0,
                lang_code: localStorage.getItem('333f-locale-lang') || 'zh_cn',
                'to-tree': 0
            }).then(res => {
                if (res.code === 200) {
                    if (type) {
                        let nowtab = Number(sessionStorage.getItem('333f-now-tab'))
                        res.data.map(item => {
                            if (nowtab == item.id) this.list = [item.banner_url]
                        })
                    } else {

                        this.solutionTabs = res.data
                        this.solutionTabs.unshift({
                            id: null,
                            category_name: this.$t('solution.n1')
                        })
                    }
                }
            })
        },
    },
};
</script>
<style scoped lang="less">
.solution {
    .solution-tiny {
        img {
            width: 100%;
            height: fit-content;
            min-height: 380px;
        }
    }

    .market-header_words {
        padding-bottom: 50px;
        font-size: 18px;
        color: @text-defauft-color;
        text-align: center;
    }

    .solution-pc-words {
        margin: 0 20px 50px 0;
        width: 50%;
    }

    .solution-m-words {
        margin: 0 auto 20px;
        width: 96%;
    }

    .solution-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        white-space: break-word;

        .words {
            padding: 0 62px;
            font-size: 16px;
            font-weight: normal;
            color: #fff;
            width: 100%;

            .title {
                text-align: center;
                font-weight: 500;
                font-size: 36px;
                color: @primaryColor;
                font-family: Arial-BoldMT;
                // white-space: nowrap;
                margin-bottom: 10px;
            }

            .time {
                text-align: center;
                // white-space: nowrap;
                margin-bottom: 5px;
            }
        }
    }

    .solutionTabs {
        font-size: 20px;
        color: @text-defauft-color;
        text-align: center;
        border-color: #f1f1f1;
        background: #f1f1f1;

        div {
            padding: 0 30px;
            min-width: 220px;
            text-align: center;
            background-color: #f1f1f1;
        }

        .solution-tabs-active {
            background-color: #fff;
            line-height: 50px;
            color: @primaryColor;
            font-weight: bold;
            border-bottom: 3px solid @primaryColor;
        }

        .solution-tabs {
            height: 50px;
            line-height: 50px;
            text-align: center;
            // font-size: 20px;
            // color: #000;
            cursor: pointer;
            // margin-right: 20px;
            // border-radius: 5px;
        }
    }

    .card {
        width: 24%;
        // max-width: 380px;
        margin-right: 1%;


        //     margin-bottom: 12px;

        //     &:not(:nth-child(4n)) {
        //         margin-right: 12px;
        //     }
        // }

    }

    @media screen and (max-width: 1024px) and (min-width: 501px) {
        .card {
            width: 49%;
            max-width: 50%;
            margin-right: 1%;
        }

        .solutionTabs div {
            min-width: unset;
        }
    }

    // @media screen and (max-width: 667px) and (min-width: 501px) {
    //     .card {
    //         width: 48%;
    //         max-width: 380px;
    //         // margin: auto;
    //     }
    // }

    @media screen and (max-width: 500px) {
        .card {
            width: 90%;
            max-width: 100%;
            margin: 10px auto;
        }

        .solutionTabs div {
            min-width: 33%;
        }
    }

    @media (max-width: 900px) {
        .solution-tiny {
            img {
                height: 400px !important;
                object-fit: cover;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution.vue